import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-151a6c11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "month-picker-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, " ", -1))
const _hoisted_3 = { class: "center" }
const _hoisted_4 = {
  key: 0,
  class: "month-picker"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "month-picker-placeholder" }
const _hoisted_8 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.monthPicker.months.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("select", {
              ref: "monthPicker",
              value: _ctx.selectedMonth,
              class: "dropdown-button",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectMonth && _ctx.selectMonth(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthPicker.months, (month, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: idx,
                  value: month
                }, _toDisplayString(_ctx.getMonthText(month)), 9, _hoisted_6))
              }), 128))
            ], 40, _hoisted_5),
            _createVNode(_component_FontAwesomeIcon, {
              class: "chevron",
              icon: _ctx.faChevronDown
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
        [_vShow, _ctx.monthPicker.months.length === 0]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "x-close-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
        }, [
          _createVNode(_component_FontAwesomeIcon, {
            class: "xmark",
            icon: _ctx.faXmark
          }, null, 8, ["icon"])
        ])
      ])
    ])
  ]))
}